import { useTheme as muiUseTheme } from "@mui/material/styles";
export const useTheme = () => {
    return muiUseTheme();
};
